var cannotLoadAjax = "Can not process your request";

$(document).ready(function () {
   var innovaApiUrl = $("#InnovaApiUrl").val();
   var innovaApiKey = $("#InnovaKey").val();
   var sku = $("#Tool").val(); 
   if(sku != null && sku != undefined && sku != ""){
     //sku = sku.trim();
    var url = innovaApiUrl + "/products/" + sku +"/key-features/?r=" + Math.random();
   
    
    $.ajax({
        type: "GET",
        crossOrigin: true,
        url: url,
        beforeSend: function (xhr) {
          xhr.setRequestHeader('inn-api-auth-ticket', innovaApiKey);
        },
        error: function (request, status, error) {
          // alert(url);
          // alert(request.status);
          // alert(request.responseText);
          // alert(status);
          //  alert(error);
          if(request.status != 0){
            alert(cannotLoadAjax);
          }
        },
        success: function (result) {
          if(result.message.success)
            $("#keyFeatureResult").html(renderKeyFeatures(result));
          if(result.data !== undefined && result.data.length > 0){
            $("#keyFeatureContent").show();
            $("#keyFeatureLink").show();
          }else{
            $("#keyFeatureContent").hide();
            $("#keyFeatureLink").hide();
          }
        }
    });    
   }
});

function renderKeyFeatures(data){
	var result = "";
  	var keyFeatures = data.data;
    if(keyFeatures !== undefined && keyFeatures.length > 0){
        
      	var j = 0;
    	 for(var i=0; i<keyFeatures.length; i++ ){
           if(i%3 ==0)
           {
           	  result +="<div class='row'>";              
           }
           j++;
           
           result +="<div class='col-md-4 mt-4'>";
           result +="<h6 class='text-primary'>"+ keyFeatures[i].header +" </h6>";
           result +="<p>"+ keyFeatures[i].content +"</p>";
           result +="</div>";
           if(j%3 ==0 || i == (keyFeatures.length-1))
           {
           	  result +="</div>";
              j = 0;
           }
         }
      	
    }else{
    	result += "No Key Feature Found.";      	
    }
  
  return result;
}